import moment from "moment";

export const getCurrentMonthDateRange = () => ({
  startDate: moment().startOf("month").format("YYYY-MM-DD"),
  endDate: moment().endOf("month").format("YYYY-MM-DD"),
});
